const stats = [
  { value: "99.9%", label: "Uptime" },
];

export default function AboutSection() {
  return (
    <section id="about" className="bg-[#0f0f0f] py-32">
      <div className="max-w-7xl mx-auto px-8">
        {/* Label */}
        <span className="inline-block text-xs font-semibold tracking-[0.25em] uppercase text-[#00d4ff] mb-4">
          About Us
        </span>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-20 items-center">
          {/* Left */}
          <div>
            <h2 className="text-5xl font-bold text-white leading-tight mb-6">
              A Team Dedicated to{" "}
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#00d4ff] to-[#0099cc]">
                iOS Innovation
              </span>
            </h2>
            <p className="text-[#9a9a9a] text-lg leading-relaxed mb-6">
              BADI D.O.O. was founded by passionate engineers who believe that every user
              deserves powerful, intuitive, and secure mobile applications. We focus exclusively
              on the iOS platform, allowing us to push the boundaries of what is possible within
              Apple&apos;s ecosystem.
            </p>
            <p className="text-[#9a9a9a] text-lg leading-relaxed mb-10">
              Our flagship products — a robust VPN solution and an intelligent device
              cleaner — reflect our deep commitment to user privacy, performance, and
              seamless experience. Every line of code we write is guided by the
              principle that security and simplicity must coexist.
            </p>

            <div className="flex items-center gap-4">
              <div className="w-1 h-14 bg-gradient-to-b from-[#00d4ff] to-transparent rounded-full"></div>
              <p className="text-white text-xl italic leading-snug">
                &ldquo;Building the future of secure, clean, and fast iOS experiences.&rdquo;
              </p>
            </div>
          </div>

          {/* Right - image + stats */}
          <div className="flex flex-col gap-6">
            <div className="relative rounded-2xl overflow-hidden h-72">
              <img
                src="https://public.readdy.ai/ai/img_res/59163b42b80ee23531b9ac6ee5f9f68c.jpg"
                alt="BADI D.O.O. team at work"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#0f0f0f]/60 to-transparent"></div>
            </div>

            {/* Stats grid */}
            <div className="grid grid-cols-1 gap-4">
              {stats.map((stat) => (
                <div
                  key={stat.label}
                  className="bg-[#1a1a1a] border border-[#2a2a2a] rounded-xl p-5"
                >
                  <div className="text-3xl font-bold text-[#00d4ff] mb-1">{stat.value}</div>
                  <div className="text-[#666] text-sm tracking-wide uppercase">{stat.label}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
